import React, { useEffect, useRef } from 'react'
import "./style.css"

const SectionHeader = ({title, subTitle}) => {
  const titleRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const currentRef = titleRef.current;
    
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className="section-title animate-section" ref={titleRef}>
      <h2 className="delay-100">{title}</h2>
      <h4 className="delay-300">{subTitle}</h4>
    </div>
  );
};

export default SectionHeader;  